<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.667 8.66669L8.00032 13.3334L3.33366 8.66669M8.00033 2.66669L8.00032 13.3334L8.00033 2.66669Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
